import { Component, inject, Input } from '@angular/core';
import { ConsultationTreatmentTypes } from '@enums/consultation-treatment-types';
import { environment } from '@environments/environment';
import { OrderCompleteDetails } from '@models/order-complete-details';
import { ConsultationRequestService } from '@services/consultation-request.service';

@Component({
  template: '',
})
export abstract class OrderCompleteInstructionsConsultationBaseComponent {
  @Input() public orderCompleteDetails: OrderCompleteDetails;
  @Input() public treatmentType: ConsultationTreatmentTypes;

  private consultationRequestService = inject(ConsultationRequestService);
  protected abstract readonly siteName: string;

  public get cardContentClass(): string {
    return environment.styles.orderCompleteInstructions.cardContentClass;
  }

  public getConsultationPageUrl(): string {
    return this.consultationRequestService.getConsultationPageUrl(
      this.treatmentType,
      this.orderCompleteDetails.transactionId,
      this.orderCompleteDetails.hash,
    );
  }
}
